import { zip5 } from "./leadUtils";

// Same key map.html used, so existing browsers keep their cached lookups.
const GEO_CACHE_KEY = "de_probate_geocache_v1";

export type GeoCache = Record<string, { lat: number; lng: number }>;

export const loadGeoCache = (): GeoCache => {
  try {
    const parsed = JSON.parse(localStorage.getItem(GEO_CACHE_KEY) ?? "{}");
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const saveGeoCache = (cache: GeoCache): void => {
  try {
    localStorage.setItem(GEO_CACHE_KEY, JSON.stringify(cache));
  } catch {
    // Quota/private-mode failures just mean re-geocoding next visit.
  }
};

/**
 * Geocodable address string for a probate lead ("addr, city, TX, zip").
 * Returns "" (too short to geocode) unless at least two parts are present.
 */
export const geoAddress = (p: {
  address: string | null;
  city: string | null;
  zip: string | null;
}): string => {
  const z = zip5(p.zip);
  const parts = [p.address, p.city, p.city || z ? "TX" : null, z].filter(
    Boolean,
  );
  return parts.length >= 2 ? parts.join(", ") : (p.address ?? "");
};
